import * as StackTrace from 'stacktrace-js';

import GLOBAL from '../util/global';
import postXHR from '../util/xhr';

import Category from '../core/types/category.type';
import ILog, { LogLevel} from '../core/types/log.type';
import IMessage, { IShared } from '../core/types/message.type';

let FORMER_JSERROR_FLAG: boolean = true;
let sharedData: IShared[] = [];
let onErrorCalled = false;
let onRejectCalled = false;

function _sendRawLogs(logs: any, ctx: any, sendSuccess: any, sendFail: any) {
    const mergedData: IMessage[] = [];
    logs.forEach((e: any) => {
        const raw: IMessage = ctx.inspect();
        const log: ILog = {
            name: e.message,
            content: e.errorStack,
            level: LogLevel.ERROR,
            padding: {
                lineNumber: e.lineNumber,
                columnNumber: e.columnNumber,
                sourceMap: e.sourceMap,
                captureMethod: e.captureMethod,
            },
            resourceUrl: e.scriptURL,
        };
        raw.log = log;
        raw.category = Category.JS_ERROR,
        mergedData.push(raw);
    });

    const postData = [{
        common: sharedData,
        body: mergedData,
    }];

    postXHR({
        data: encodeURIComponent(JSON.stringify(postData)),
        success: () => {
            if (sendSuccess) {
                sendSuccess();
            }
        },
        failure: () => {
            if (sendFail) {
                sendFail();
            }
        },
    });
}

function sendJsMap(ctx: any, log: any, errorObj: any) {
    if (!errorObj) {
        _sendRawLogs([log], ctx, null, null);
        return;
    }
    StackTrace.fromError(errorObj).then((stackframes: any) => {
        log.sourceMap = stackframes.map((sf: any) => {
            return sf.toString();
        }).join('\n');
        _sendRawLogs([log], ctx, null, null);
    }).catch((err: any) => {
        log.sourceMap = err ? err.toString() : 'stacktrace error';
        _sendRawLogs([log], ctx, null, null);
    });
}

function _JSRuntime(ctx: any) {
    const globalOnError = GLOBAL.onerror;
    const globalOnUnhandledRejectionr = GLOBAL.onunhandledrejection;

    // this method is compatibily better than addEventListener but has the risk of being overridden.
    GLOBAL.onerror = (errorMessage: string, scriptURL: string, lineNumber: number, columnNumber: number, errorObj: any) => {
        onErrorCalled = true;
        console.log('js onerror', errorObj); // eslint-disable-line
        try {
            const log  = {
                message: errorMessage || 'Not Found',
                scriptURL,
                lineNumber,
                columnNumber,
                errorStack: errorObj && errorObj.stack || 'Not Found',
                captureMethod: 'window.onerror',
            };
            sendJsMap(ctx, log, errorObj);
        } catch (e) {
            console.log(e);
        }
        if (globalOnError) {
            globalOnError.apply(GLOBAL, arguments);
        }
    };

    GLOBAL.addEventListener("error", (e: any) => {
        console.log('js error', e); // eslint-disable-line
        if (onErrorCalled) {
            return;
        }
        try {
            const log: any = {
                message: e.error && e.error.message || 'Not Found',
                scriptURL: e.filename,
                lineNumber: e.lineno,
                columnNumber: e.colno,
                errorStack: e.error && e.error.stack || 'Not Found',
                captureMethod: 'addEventListener error',
            };
            sendJsMap(ctx, log, e.error);
        } catch (e) {
            console.log(e);
        }
    });

    const rejectionHandler = (event: any, method: string) => {
        try {
            let message: string = 'Not Found';
            let scriptURL: string = 'Not Found';
            let errorStack: string = 'Not Found';
            let columnNumber: number = -1;
            let lineNumber: number = -1;

            if (event && event.reason) {
                if (typeof event.reason === 'string') {
                    message = event.reason;
                } else if (typeof event.reason === 'object') {
                    if (event.reason.message) {
                        message = event.reason.message;
                    }
                    if (event.reason.stack) {
                        errorStack = event.reason.stack;
                    }
                    if (event.reason.column) { // does not exists in chrome but in sarafi
                        columnNumber = event.reason.column;
                    }
                    if (event.reason.line) { // does not exists in chrome but in sarafi
                        lineNumber = event.reason.line;
                    }
                }
            }
            if (event && event.target && event.target.location.href) { // not exists in some android mobile or IE
                scriptURL = event.target.location.href;
            }

            const log: any = {
                message,
                scriptURL,
                lineNumber,
                columnNumber,
                errorStack,
                captureMethod: method,
            };

            sendJsMap(ctx, log, event.reason);
        } catch (e) {
            console.log(e);
        }
    };

    GLOBAL.onunhandledrejection = (e: any) => {
        console.log('onunhandledrejection', e); // eslint-disable-line
        onRejectCalled = true;
        rejectionHandler(e, 'window.onunhandledrejection');
        if (globalOnUnhandledRejectionr) {
            globalOnUnhandledRejectionr.apply(GLOBAL, arguments);
        }
    };

    // this method is compatibily better than addEventListener but has the risk of being override.
    GLOBAL.addEventListener("unhandledrejection", (event: any) => {
        console.log('unhandledrejection', event); // eslint-disable-line
        if (onRejectCalled) {
            return;
        }
        rejectionHandler(event, 'addEventListener unhandledrejection');
    });
}

function JSMiddleware(ctx: any, next: any): any {
    if (FORMER_JSERROR_FLAG) {
        sharedData = ctx.getShared();
        FORMER_JSERROR_FLAG = false;
        _JSRuntime(ctx);
    }
    next();
}

export default JSMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/js-middleware.ts